/**
 *  Service for Payments
 *  @author Livescore <jsmith@example.com>
 *  @copyright 2025 livescore
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PaymentProduct, PaymentTransactions, SerializeData } from '@interfaces/payment.interface';

import { CommonService } from '../shared/common.service';

import URL_CONFIG from '../config/url.config';

import { LangService } from './lang.service';


@Injectable({
    providedIn: 'root',
})
export class PaymentService {
    public constructor(
        private http: HttpClient,
        private common: CommonService,
        private lang: LangService,
    ) {

    }


    public getProducts(): Observable<PaymentProduct[]> {
        const url = URL_CONFIG.api.paymentProducts;
        const params = null;
        const options = params !== null ? { params } : {};
        return this.http.get<PaymentProduct[]>(url, options).pipe(
            catchError(this.common.errorCallback), // then handle the error
        );
    }

    public getTransactions(sessionId?: string): Observable<PaymentTransactions[]> {
        const url = URL_CONFIG.api.paymentTransactions;
        let params = null;

        if (sessionId) {
            params = { session_id: sessionId };
        }
        const options = params !== null ? { params } : {};
        return this.http.get<PaymentTransactions[]>(url, options).pipe(
            catchError(this.common.errorCallback), // then handle the error
        );
    }

    public mapSerializeData(data: Record<string, any>):SerializeData {
        if (data && typeof data === 'object' && '*_values' in data) {
            return data['*_values'];
        }

        return data;
    }
}
